import { Mp4Box } from "./Mp4Box.class";

export class ftyp extends Mp4Box {}
